module.exports = __webpack_public_path__ + "img/sensor_1_0.8dd3cf27.png";